"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Package, FileText, TrendingUp, Shield, Clock, Star } from "lucide-react";
const buyerFeatures = [{
  id: 1,
  icon: Package,
  title: "Real-Time Tracking",
  description: "Monitor your shipments with live updates and GPS tracking for complete visibility throughout the supply chain."
}, {
  id: 2,
  icon: FileText,
  title: "Quality Reports",
  description: "Access comprehensive quality control documents, certifications, and inspection reports for every order."
}, {
  id: 3,
  icon: TrendingUp,
  title: "Market Analytics",
  description: "Stay informed with real-time market trends, pricing insights, and demand forecasting tools."
}, {
  id: 4,
  icon: Shield,
  title: "Compliance Management",
  description: "Ensure regulatory compliance with automated documentation and verification processes."
}, {
  id: 5,
  icon: Clock,
  title: "Order History",
  description: "Review complete purchase history with detailed records, invoices, and transaction data."
}, {
  id: 6,
  icon: Star,
  title: "Supplier Ratings",
  description: "Make informed decisions with performance metrics, reviews, and quality ratings for every supplier."
}];
export default function BuyerPortalFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section id="buyer-portal-features" ref={ref} className="relative py-24 bg-[hsl(215,70%,12%)] overflow-hidden">
      <div className="container mx-auto px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-4 text-white">
            Buyer Portal Features
          </h2>
          <p className="text-lg text-[hsl(210,10%,90%)] max-w-3xl mx-auto">
            Empowering buyers with comprehensive tools for seamless procurement, quality assurance, and supply chain management.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {buyerFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.id} data-index={i} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-[hsl(215,70%,15%)] border border-[hsl(65,70%,50%)]/20 hover:border-[hsl(65,70%,50%)]/40 transition-all duration-[var(--duration-medium)] hover:-translate-y-2 hover:shadow-[0_12px_24px_rgba(0,0,0,0.25)]">
                  <CardHeader>
                    <div className="mb-4 inline-flex p-3 rounded-sm bg-[hsl(65,70%,50%)]/10 group-hover:scale-110 transition-transform duration-[var(--duration-medium)]">
                      <Icon className="w-8 h-8 text-[hsl(65,70%,50%)] transition-transform duration-[var(--duration-medium)] hover:scale-110" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl text-white mb-2">
                      {feature.title}
                    </CardTitle>
                    <CardDescription className="text-[hsl(210,10%,90%)] leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}